var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sign-page',{attrs:{"title-text":"字段配置","request":_vm.request,"column-list":_vm.columnList,"form-parms-add":_vm.formParmsAdd,"form-parms-update":_vm.formParmsUpdate,"need-data-file":true}})}
var staticRenderFns = []

export { render, staticRenderFns }